import { colors } from '../../Colors/colors'

export const calls = {
   light: {
      agentsOptionsSelector: {
         agentNameTextColor: 'text-gray-700',
         iconFillColor: colors['gray-500']
      },

      callLogsHeader: {
         containerBorderColor: 'border-gray-300',
         boardNameTextColor: 'text-gray-900',
         dividerBGColor: 'bg-gray-300',
         filledTabBar: {
            borderColor: 'border-gray-100',
            bgColor: 'bg-gray-200',
            selectedTabTextColor: 'text-gray-700',
            tabTextColor: 'text-gray-500'
         },
         pipelineNameTextColor: 'text-gray-700',
         refreshIconColor: colors['gray-700']
      },

      callLogsBody: {
         bgColor: 'bg-gray-100',
         callLogCard: {
            cardBGColor: 'bg-base-white',
            clockIconColor: colors['gray-600'],
            defaultTextColor: 'text-gray-700',
            incomingCallBGIconColor: 'bg-green-50',
            incomingCallIconColor: colors['green-600'],
            missedCallIconBGColor: 'bg-error-50',
            missedCallIconColor: colors['error-600'],
            noAgentBgColor: 'bg-gray-100',
            noAgentTextColor: 'tex-gray-600',
            outgoingCallBGIconColor: 'bg-primary-50',
            outgoingCallIconColor: colors['primary-600'],
            phoneNumberIconColor: colors['gray-600'],
            phoneNumberTextColor: 'text-gray-600',
            selectedBorderColor: 'border-primary-100'
         },
         skeletonBaseColor: colors['base-white'],
         skeletonHighlightColor: colors['gray-200']
      },

      common: {
         agentAccessDeniedView: {
            badgeContainerBGColor: 'bg-white',
            badgeContainerBorderColor: 'border-gray-200'
         },
         noAccessOrNoDataView: {
            descriptionColor: 'text-gray-500',
            titleColor: 'text-gray-800'
         },
         pipelineAccessDeniedView: {
            badgeContainerBGColor: 'bg-white',
            badgeContainerBorderColor: 'border-gray-200'
         }
      },

      pushNotificationCard: {
         cardBorderColor: 'border-gray-100',
         phoneIconColor: colors['error-600'],
         phoneIconInnerBGColor: colors['error-100'],
         phoneIconOuterBGColor: colors['error-50'],
         closeIconColor: colors['gray-500'],
         arrowIconColor: colors['primary-600']
      }
   },

   dark: {}
}
